define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    var CategoriesViewController = require('web-agent-viewControllers/CategoriesViewController');

    var BaseCategoriesPanelViewController = ViewController.extend({

        ControllerName: "BaseCategoriesPanelViewController",
        applicationType: "BaseCategoriesPanelViewController",

        LPViewMap: {
            wrapper: '.categories_panel_wrapper',
            contentPlaceHolder: '.lpview_categories_panel_content_placeholder',
            statePlaceHolder: '.lpview_categories_panel_state_placeholder',
            errorMessage: '.lpview_error_message_text',
            refreshAction: '.lpview_refresh_action',
            errorInfoLink: '.lpview_error_info_link'
        },

        LPStateMap: {
            error: "error",
            partial: "partial",
            fetching: "fetching",
            success: "success"
        },

        initialize: function (constructorData) {
            this.searchInputVC = constructorData.searchInputVC;
            if (constructorData.events) {
                this.visibleRowsCountCallback = constructorData.events.visibleRowsCountCallback;
            }
            this.preSearchCallback = constructorData.preSearch;
            this.postSearchCallback = constructorData.postSearch;
        },

        events: function () {
            this.bindModel({modelPath: this.getRootModelPath() + ".state", callback: this.dataStateChanged});
        },

        render: function () {
            this.initView();
        }

    });


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */


    BaseCategoriesPanelViewController.prototype.preSearch = function() {
        if (this.preSearchCallback) {
            this.preSearchCallback();
        }
    };

    BaseCategoriesPanelViewController.prototype.postSearch = function() {
        if (this.postSearchCallback) {
            this.postSearchCallback();
        }
    };

    /**
     * get the configuration of the component.
     */
    BaseCategoriesPanelViewController.prototype.getConfiguration = function () {
        return {
            tableConfig: {
                modelController: this.modelController,
                ignoreSectionHover: true,
                modelPath: null,
                modelData: [],
                sectionTemplateFile: null,
                dataBinder: this.dataBinder,
                dataRenderer: this.dataRenderer,
                disableSectionsDuringFilter: false,
                preSearch: this.preSearch.bind(this),
                postSearch: this.postSearch.bind(this),
                context: this
            }
        };
    };

    /**
     * the data binder for the categories table.
     * @abstract
     */
    BaseCategoriesPanelViewController.prototype.dataBinder = {
        visibleRowsCountChange: function (data) {
            this.handleVisibleRowsCountChange(data);
        }
    };


    /**
     * the data renderer for the categories table.
     * @abstract
     */
    BaseCategoriesPanelViewController.prototype.dataRenderer = void 0;

    /**
     * initializing the view
     */
    BaseCategoriesPanelViewController.prototype.initView = function () {
        createWrapperView.call(this);
        createTableView.call(this);

        function createWrapperView() {
            var wrapperTemplate = require('web-agent-templates/LP_categories_panel.html');
            // var wrapperTemplate = lpUtils.loadResource('web-agent-templates/LP_categories_panel.html');
            var errorMessage = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_errorMessage" + "}}" : "";
            var errorInfoLink = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_errorInfoLink" + "}}" : "";
            var errorRefresh = this.configuration.textPrefix ? "{{" + this.configuration.textPrefix + "_error_refresh" + "}}" : "";

            wrapperTemplate = this.injectTextDefaults(wrapperTemplate, {
                errorMessage: errorMessage,
                error_refresh: errorRefresh,
                errorInfoLink: errorInfoLink
            });

            var view = this.createView({template: wrapperTemplate, wrapWithDiv: false});

            if (this.configuration.cssClass) {
                this.addClass(view, this.configuration.cssClass);
            }

            if (!this.updateDataCallback) {
                this.lpHide(this.LPViewMap.refreshAction, '.error_widget');
            }
        }

        function createTableView() {

            var tableConfiguration = this.configuration.tableConfig;
            if (this.searchInputVC) {
                tableConfiguration.filterView = this.searchInputVC.searchInput;
            }

            this.categoriesView = new CategoriesViewController({
                modelController: this.modelController,
                tableConfig: tableConfiguration,
                search: false // using the main search as the proxy.
            });

            this.addViewController({
                viewController: this.categoriesView,
                target: this.LPViewMap.contentPlaceHolder
            });

            // this is for legacy support. to not brake all other controllers based on exposing of the table and search views.
            this.categoriesTable = this.categoriesView.categoriesTable;
        }
    };

    /**
     * registaring the instance of the tab's manager in the panel.
     * @param tabsManager
     * @param index
     */
    BaseCategoriesPanelViewController.prototype.registerTabsManager = function (tabsManager, index) {
        this.tabsVC = tabsManager;
        this.tabIndex = index;
    };

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    BaseCategoriesPanelViewController.prototype.handleVisibleRowsCountChange = function (data) {
        this.updateTabTitle('(' + data.numOfRows + ')');
        if (_.isFunction(this.visibleRowsCountCallback)) {
            this.visibleRowsCountCallback.call(this, {
                panel: this,
                tabIndex: this.tabIndex,
                visibleCount: data.numOfRows,
                isFiltered: data.isFiltered
            });
        }
    };

    /**
     * the content update method.
     * @abstract
     */
    BaseCategoriesPanelViewController.prototype.updateContent = function () {
        throw new Error('this method must be implemented.');
    };

    /**
     * update the tab title.
     * @param title
     */
    BaseCategoriesPanelViewController.prototype.updateTabTitle = function (title) {
        if (this.tabsVC) {
            this.tabsVC.setTabTitle(this.tabIndex, title);
        }
    };

    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */


    /**
     * setting an error message in the container.
     * @param errMsg
     */
    BaseCategoriesPanelViewController.prototype.setErrorMessage = function (errMsg) {
        var errMsgElement = this.getFirstElement(this.LPViewMap.errorMessage);
        errMsgElement.innerHTML = errMsg;
    };

    /**
     * handle state change for the root model.
     * @param data
     */
    BaseCategoriesPanelViewController.prototype.dataStateChanged = function (data) {
        if (data && data.newValue) {
            this.setState(data.newValue);
        }
    };

    /**
     * set the panel state.
     * @param state
     */
    BaseCategoriesPanelViewController.prototype.setState = function (state) {
        var stateClasses = ["loading", "error", "partial", "success"];
        var stateIndex = stateClasses.indexOf(state);
        if (stateIndex >= 0) {
            stateClasses.splice(stateIndex, 1);
        }
        //***Because we have multi-instances of this element in the DOM, it's crucial that we fetch the element prior to the add/remove function
        var wrapper = this.getFirstElement(this.LPViewMap.wrapper);
        this.removeClass(wrapper, stateClasses);
        if (state === this.LPStateMap.fetching) {
            state = 'loading';
        }

        this.addClass(wrapper, state);
        if (state === this.LPStateMap.error && this.updateDataCallback) {
            this.bindViewEvent({
                selector: this.LPViewMap.refreshAction,
                DOMEvent: "click",
                callback: this.refreshClicked
            });
        }

        if (state === this.LPStateMap.error && this.handleErrorState) {
            this.handleErrorState();
        }
    };

    /**
     * handle a refresh button click.
     */
    BaseCategoriesPanelViewController.prototype.refreshClicked = function () {
        this.unbindViewEvent({
            selector: this.LPViewMap.refreshAction,
            DOMEvent: "click",
            callback: this.refreshClicked
        });
        this.updateDataCallback.call(this);
    };

    /**
     * retrieve the root model path.
     * @returns {*|string|string|string}
     */
    BaseCategoriesPanelViewController.prototype.getRootModelPath = function () {
        return this.configuration.rootModelPath;
    };

    /**
     * bind the state events
     */
    BaseCategoriesPanelViewController.prototype.bindEvents = function () {
        this.bindModel({modelPath: this.getRootModelPath() + ".state", callback: this.dataStateChanged});
    };

    /**
     * unbind the state events.
     */
    BaseCategoriesPanelViewController.prototype.unbindEvents = function () {
        this.unbindModel({modelPath: this.getRootModelPath() + ".state", callback: this.dataStateChanged});
    };


    /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

    /**
     * update the visitor id in the panel.
     * @param visitorId
     */
    BaseCategoriesPanelViewController.prototype.updateVisitor = function (visitorId) {
        // Unbind to the old visitorId, if exist.
        var oldVisitorId = this.focusedVisitorId;
        if (oldVisitorId) {
            var oldParticipantPath = lpTag.WebAgent.logicController.getParticipantPath(oldVisitorId);
            this.unbindModel({modelPath: oldParticipantPath + '.chats', callback: this.updateContent});
            this.unbindModel({modelPath: oldParticipantPath + '.participantTag', callback: this.handleParticipantTag});
            this.unbindModel({modelPath: oldParticipantPath + '.participantInfo.acceptedEngagement', callback: this.updateContent});
        }
        // set and bind to the new visitorId, if exist.
        this.focusedVisitorId = visitorId;
        if (visitorId) {
            var newParticipantPath = lpTag.WebAgent.logicController.getParticipantPath(this.focusedVisitorId);
            this.bindModel({modelPath: newParticipantPath + '.chats', callback: this.updateContent});
            this.bindModel({modelPath: newParticipantPath + '.participantTag', callback: this.handleParticipantTag});
            this.bindModel({modelPath: newParticipantPath + '.participantInfo.acceptedEngagement', callback: this.updateContent});
        }
    };

    /**
     * Read the number of results in the Table container and match it.
     */
    BaseCategoriesPanelViewController.prototype.updateTabTitleByTableContent = function(){
        this.updateTabTitle('(' + this.categoriesTable.getNumOfVisibleRows() + ')');
    };

    /**
     * get the panel ui state.
     * @returns {{openSectionsIds: *, openSectionsFilterIds: *, isFilterInit: *}}
     */
    BaseCategoriesPanelViewController.prototype.getUiState = function () {
        return this.categoriesTable.getTableSectionsState();
    };

    /**
     * restoring the ui state of the panel
     * @param state
     */
    BaseCategoriesPanelViewController.prototype.setUiState = function (state) {
        // the TableViewController should not save the state of the filter, we are saving the Expended sections on
        // the 'SetUiState' and restoring it accordingly when needed, if the flag will be inherited from the state it will
        // override the expended sections when exiting the search and focusing out.
        state.isFilterInit = false;

        this.categoriesTable.setTableSectionsState(state, true);
    };

    /**
     * decorate with the tag color.
     * @param data
     */
    BaseCategoriesPanelViewController.prototype.handleParticipantTag = function (data) {
        this.categoriesTable.changeHighlightColor(data.newValue);
    };

    /***
     * clear the search filter.
     */
    BaseCategoriesPanelViewController.prototype.clearFiltering = function () {
        this.categoriesTable.clearFiltering();
    };


    return BaseCategoriesPanelViewController;

});
